/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Media_Tab_Import_ButtonInputs */



/**
* | output |
* | --- |
* | "Import Media" |
*
* @param {Media_Tab_Import_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const media_tab_import_button = /** @type {((inputs?: Media_Tab_Import_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_Tab_Import_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Importer des médias")
	if (locale === "de") return /** @type {LocalizedString} */ ("Importmedien")
	if (locale === "it") return /** @type {LocalizedString} */ ("Importa Media")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Импорт медиафайлов")
	if (locale === "es") return /** @type {LocalizedString} */ ("Importar medios")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("进口媒体")
	if (locale === "ja") return /** @type {LocalizedString} */ ("輸入メディア")
	if (locale === "hi") return /** @type {LocalizedString} */ ("आयात मीडिया")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Importar mídia")
	return /** @type {LocalizedString} */ ("Import Media")
});